import { useUserStore } from "../stores/user-store"
import { PermissionAction } from "@shared/components/core/helpers/securityTypes"
import { useGlobalStore } from "@/stores/global-store"

export const canWithAction = (permissionCode: string, action: PermissionAction): boolean => {
  const store = useUserStore()
  const user = store.user
  const permission = user.permissions.find(
    (p) => (p.code.includes("-") ? p.code.split("-")[0] : p.code).toLowerCase() === permissionCode?.toLowerCase(),
  )

  if (!permission) return false
  return (permission.action & action) !== 0
}

export const can = (permissionCode: string): boolean => {
  const store = useUserStore()
  const userPermissions = store.user.permissions.map((p) => p.code.toLowerCase())
  userPermissions.push(...(store.user.specialAttributes?.map((s) => s.toLowerCase()) || []))

  const permission = userPermissions.find(
    (p) => (p.includes("-") ? p.split("-")[0] : p).toLowerCase() === permissionCode?.toLowerCase(),
  )
  if (!permission) return false
  return true
}

export const canAccessRoute = (route: string): boolean => {
  const store = useUserStore()
  const globalStore = useGlobalStore()
  const menuOption = globalStore.menuHierarchy.find((m) => m.route === route)

  if (!menuOption?.securityResources || menuOption?.securityResources?.trim() === "") {
    return true
  }

  const requiredPermissions = menuOption?.securityResources?.split(",").map((r) => r.trim().toLowerCase()) || []
  const userPermission = store.user.permissions.map((p) =>
    (p.code.includes("-") ? p.code.split("-")[0] : p.code).toLowerCase(),
  )
  userPermission.push(...(store.user.specialAttributes?.map((s) => s.toLowerCase()) || []))

  return requiredPermissions.some((rp) => userPermission.includes(rp))
}
